import { apiClient } from '@/core/api';
import { orgApiPathForOrg } from '@/rve/orgMediaUrls';
import type {
  StockAudioItem,
  StockImageItem,
  StockSearchResponse,
  StockVideoItem,
} from '@/rve/stockTypes';

export interface StockSearchParams {
  query: string;
  page?: number;
  perPage?: number;
  orientation?: 'landscape' | 'portrait' | 'square';
}

export type { StockAudioItem, StockImageItem, StockSearchResponse, StockVideoItem };

/** Search org-proxied Pexels stock (CDN URLs in items). */
export async function searchStock(
  orgId: number,
  type: 'image',
  params: StockSearchParams,
): Promise<StockSearchResponse & { items: StockImageItem[] }>;
export async function searchStock(
  orgId: number,
  type: 'video',
  params: StockSearchParams,
): Promise<StockSearchResponse & { items: StockVideoItem[] }>;
export async function searchStock(
  orgId: number,
  type: 'audio',
  params: StockSearchParams,
): Promise<StockSearchResponse & { items: StockAudioItem[] }>;
export async function searchStock(
  orgId: number,
  type: 'image' | 'video' | 'audio',
  params: StockSearchParams,
): Promise<StockSearchResponse> {
  const search = new URLSearchParams({
    type,
    query: params.query,
    page: String(params.page ?? 1),
    per_page: String(params.perPage ?? 15),
  });
  if (params.orientation) {
    search.set('orientation', params.orientation);
  }

  return apiClient<StockSearchResponse>(
    `${orgApiPathForOrg(orgId, '/stock/search')}?${search.toString()}`,
  );
}
